import { YUNO, YUNO_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const yunoAction =
  (page, size, filters = {}) =>
  async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const params = { page, size, ...filters };
      const response = await axiosTokenInstance.get(`api/report/transaction-yuno`, {
        params,
      });

      const { data, status } = response || {};

      dispatch({
        type: YUNO,
        payload: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: YUNO_ERROR,
        payload: e || {},
      });
    }
  };
